import {Component, OnInit} from "@angular/core";
import {Preferences, LocalizationBundles} from "common-angular-module";
import {StartECasePreferencesService} from "../start-ecase-preferences-service";
import {MenuItem} from "../models/menu-item";
import {isUndefined} from "util";
import {StartECaseService} from "../start-ecase-service";
import {ServiceSet} from "../models/service-set";
import sortBy from 'lodash/sortBy';

declare var $: any;
@Component({
    selector: "app-start-ecase-preferences",
    templateUrl: "./start-ecase-preferences.component.html",
    styleUrls: ["./start-ecase-preferences.component.css"]
})
export class StartECasePreferencesComponent implements OnInit {
    preferences: Preferences = new Preferences();
    dJSON: any = JSON;
    preferenceService: StartECasePreferencesService;
    startECaseService: StartECaseService;
    serviceSets: ServiceSet[] = [];
    sets: MenuItem[];

    constructor(preferenceService: StartECasePreferencesService, startECaseService: StartECaseService) {
        this.preferenceService = preferenceService;
        this.startECaseService = startECaseService;
    }

    ngOnInit() {
        if (document["preferences"] !== "") {
            this.preferences = document["preferences"];
            if (this.preferences.localization === undefined) {
                this.preferences.localization = new LocalizationBundles();
            }
            if (this.preferences["servicesWithECaseSetAsURL"] === undefined) {
                this.preferences["servicesWithECaseSetAsURL"] = false;
            }
            if (this.preferences["filterByAccountGroup"] === undefined) {
                this.preferences["filterByAccountGroup"] = false;
            }
            /* If typeView was not set yet, sets default typeView value */
            if (!this.preferences["typeView"]) {
                this.preferences["typeView"] = this.preferences["listView"] ? 'list' : 'tabs';
            }
        } else {
            this.preferences = new Preferences();
            this.preferences["orbeonProxyURL"] = "/lomake/-/orbeonproxy/ecase/${eCaseId}/edit";
            this.preferences["publicServiceURL"] = "/public-api/app-start-ecase-public-service/";
            this.preferences["typeView"] = 'list';
            this.preferences["onlyResults"] = false;
            this.preferences["sortServicesAlphabetically"] = true;
            this.preferences.localization = new LocalizationBundles();
            this.preferences["setIds"] = [];
            this.preferences["serviceSetsSortOrder"] = [];
            this.preferences["loadbs4styles"] = true;
            this.preferences["servicesWithECaseSetAsURL"] = false;
            this.preferences["filterByAccountGroup"] = false;
            document["preferences"] = this.preferences;
        }

        this.startECaseService.findAll().subscribe(serviceSets => {
            this.serviceSets = serviceSets;
            if (this.preferences["serviceSetImageUrls"] === undefined) {
                this.preferences["serviceSetImageUrls"] = {};

                for (let i = 0; i < serviceSets.length; i++) {
                    this.preferences["serviceSetImageUrls"][serviceSets[i].name] = {};

                    for (let j = 0; j < serviceSets[i].services.length; j++) {
                        const serviceName = serviceSets[i].services[j].name;
                        this.preferences["serviceSetImageUrls"][serviceSets[i].name][serviceName] = '';
                    }
                }
            }
          });

        /* Navigation to services to set their URLs */
        document.querySelector('html').style['scroll-behavior'] = 'smooth';
        document.querySelector('#goToServiceSets').addEventListener('click', () =>  window.location.hash = '#serviceSets');

        this.preferenceService.findAllServiceSets().subscribe(sets => {
            this.sets = sets;
            for (let i = 0; i < this.sets.length; i++) {
                for (let j = 0; j < this.preferences["setIds"].length; j++) {
                    if (this.sets[i].id === this.preferences["setIds"][j]) {
                        this.sets[i].selected = true;
                        break;
                    }
                }
            }

            // service order by preference
            const sortServiceSetsManually = this.preferences['sortServiceSetsManually'];
            if (sortServiceSetsManually) {
                const sortedNames = this.preferences["serviceSetsSortOrder"];
                if (sortedNames && !!sortedNames.length) {
                    sets.forEach(ss => ss.index = sortedNames.findIndex(o => o === ss.name));
                    this.sets = sortBy(this.sets, 'index');
                }
            }
            this.toggleServiceSetDragging(sortServiceSetsManually);
        });
    }

    onSetChange(set: MenuItem) {
        if (isUndefined(this.preferences["setIds"].find(x => x === set.id))) {
            this.preferences["setIds"].push(set.id);
        } else {
            this.preferences["setIds"].splice(this.preferences["setIds"].indexOf(set.id), 1);
        }
    }

    onSortServiceSetsChange() : void {
        const sortServiceSetsManually = this.preferences['sortServiceSetsManually'];
        this.sets = sortBy(this.sets, sortServiceSetsManually ? 'index' : 'id');
        this.toggleServiceSetDragging(sortServiceSetsManually);
        this.preferences["serviceSetsSortOrder"] = [];
    }

    onServiceSetsReorder(sets: any) {
        if (sets && !!sets.length && this.preferences['sortServiceSetsManually']) {
            this.preferences["serviceSetsSortOrder"] = sets.map(s => s.name);
        }
    }

    private toggleServiceSetDragging(sortServiceSetsManually: boolean): void {
        // prevent dragging if preference is disabled
        setTimeout(() => {
            Array.from(document.getElementsByClassName('sortable-item')).forEach(element => {
                element.parentElement.setAttribute('draggable',  sortServiceSetsManually.toString());
                element.parentElement.style.cursor = sortServiceSetsManually ? 'grab' : 'default';
            });
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/start-ecase-preferences/start-ecase-preferences.component.ts